import { render, staticRenderFns } from "./EditReportDetails.vue?vue&type=template&id=239ba3fa&scoped=true&"
import script from "./EditReportDetails.vue?vue&type=script&lang=js&"
export * from "./EditReportDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239ba3fa",
  null
  
)

export default component.exports